import axios from 'axios';
import { notify } from "@/main";
import { API } from '@/config/api';

const state = {
    translating: false,
    generatingAudio: false,
    translatedText: '',
    generatedAudioUrl: '',
};

const mutations = {
    SET_TRANSLATING(state, translating) {
        state.translating = translating;
    },
    SET_GENERATING_AUDIO(state, generating) {
        state.generatingAudio = generating;
    },
    SET_TRANSLATED_TEXT(state, text) {
        state.translatedText = text;
    },
    SET_GENERATED_AUDIO_URL(state, url) {
        state.generatedAudioUrl = url;
    },
};

const actions = {
    /**
     * Translate text from one language to another
     * @param {Object} payload - { text, originalLanguage, translatedLanguage }
     */
    async translateText({ commit }, { text, originalLanguage, translatedLanguage }) {
        commit('SET_TRANSLATING', true);

        try {
            const data = {
                text,
                originalLanguage,
                translatedLanguage,
            };

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            };

            const response = await axios.post(
                API.TRANSLATE_TEXT,
                data,
                config
            );

            const translatedText = response.data.results;
            commit('SET_TRANSLATED_TEXT', translatedText);

            notify("Text successfully translated!", "success");

            return { success: true, translatedText };
        } catch (error) {
            
            notify("Translation failed", "error");
            return { success: false, error };
        } finally {
            commit('SET_TRANSLATING', false);
        }
    },

    /**
     * Generate audio from text using Text-to-Speech
     * @param {Object} payload - { text, voiceName, extraPrompt }
     */
    async generateSpeech({ commit }, { text, voiceName, extraPrompt = null }) {
        commit('SET_GENERATING_AUDIO', true);

        try {
            const formData = new FormData();
            formData.append("text", text);
            formData.append("voice_name", voiceName);

            if (extraPrompt) {
                formData.append("extra_prompt", extraPrompt);
            }

            const response = await axios.post(
                API.TTS_GENERATE,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const audioUrl = response.data.url;
            commit('SET_GENERATED_AUDIO_URL', audioUrl);

            notify("Audio generated successfully!", "success");

            return { success: true, audioUrl };
        } catch (error) {
            
            notify("Failed to generate speech. Please try again.", "error");
            return { success: false, error };
        } finally {
            commit('SET_GENERATING_AUDIO', false);
        }
    },
};

const getters = {
    isTranslating: state => state.translating,
    isGeneratingAudio: state => state.generatingAudio,
    translatedText: state => state.translatedText,
    generatedAudioUrl: state => state.generatedAudioUrl,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
